import Glide, { Options } from "@glidejs/glide/dist/glide.esm";

// new Glide('.cats', {
//     type: 'carousel',
//     perView: 3,
//     peek: 50,
//    
//     dragThreshold: 10,
//     swipeThreshold: 10,
//     breakpoints: {
//         768: {
//             perView: 1
//         },
//         1200: {
//             perView: 2
//         }
//     }
// }).mount();

const collections = document.querySelectorAll('.col-prods')
const conf = {
    type: 'carousel',
    peek: 50,
    perView: 3,
    dragThreshold: 10,
    swipeThreshold: 10,
    breakpoints: {
        768: {
            perView: 1
        },
        1200: {
            perView: 2
        }
    }
    
};
collections.forEach(item => {
    new Glide(item, conf).mount()
});

$(function() {
    var newHeight = $(".bundle-prods").outerHeight() + 210;
    $(".col-first").css('min-height', newHeight);
    
    window.onresize = function() {
        var newHeight = $(".bundle-prods").outerHeight() + 210;
        $(".col-first").css('min-height', newHeight);
    }
})


    // Countdown Timer for November 30th at midnight
    $(function() {
        function updateCountdown() {
            // Target date: November 30th at midnight
            const targetDate = new Date();
            targetDate.setMonth(11); // November is month 10 (0-indexed)
            targetDate.setDate(17);
            targetDate.setHours(23, 59, 59, 59);

            // If the date has already passed this year, target next year
            if (targetDate < new Date()) {
                targetDate.setFullYear(targetDate.getFullYear() + 1);
            }

            // Get current time
            const now = new Date().getTime();
            const distance = targetDate.getTime() - now;

            // Calculate time units
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Update DOM elements
            const daysEl = document.getElementById('days');
            const hoursEl = document.getElementById('hours');
            const minutesEl = document.getElementById('minutes');
            const secondsEl = document.getElementById('seconds');

            if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
            if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
            if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
            if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');

            // If countdown is finished
            if (distance < 0) {
                clearInterval(timerInterval);
                if (daysEl) daysEl.textContent = '00';
                if (hoursEl) hoursEl.textContent = '00';
                if (minutesEl) minutesEl.textContent = '00';
                if (secondsEl) secondsEl.textContent = '00';
            }
        }

        // Update countdown immediately on load
        updateCountdown();

        // Update every second
        const timerInterval = setInterval(updateCountdown, 1000);
    });